/** Shared operational occupancy day (Hatachana + NPL line charts). */
export const IL_TZ = "Asia/Jerusalem";

/** Day starts at 04:00 Israel — after late-night OUT traffic settles. */
export const OCCUPANCY_DAY_START_HOUR = 4;

/**
 * Operational occupancy day key (YYYY-MM-DD in Asia/Jerusalem).
 * Hours 00:00–03:59 belong to the previous occupancy day.
 *
 * Implementation: shift the instant back by dayStartHour, then take the
 * Israel calendar date of the shifted instant.
 */
export function occupancyDayKey(value, dayStartHour = OCCUPANCY_DAY_START_HOUR) {
  const d = new Date(value);
  if (isNaN(d.getTime())) return "";
  const shifted = new Date(d.getTime() - dayStartHour * 60 * 60 * 1000);
  return shifted.toLocaleDateString("sv-SE", { timeZone: IL_TZ });
}

export function currentOccupancyDayKey(dayStartHour = OCCUPANCY_DAY_START_HOUR) {
  return occupancyDayKey(new Date(), dayStartHour);
}
